module.exports = __webpack_public_path__ + "img/car_00016.fbc3b15d.jpg";